import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import 'core-js/modules/es.object.assign.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Stack, Box, TextField, Text, AssistChip } from '@hub-la/design-system';
import { CircularProgress, Avatar } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextNewlineLengthUseCase } from '../../../usecases/text-newline-length.js';
import img from '../../assets/default-user-avatar.js';

const InputComment = ({
  showAvatar: _showAvatar = true,
  avatarSize: _avatarSize = 40,
  defaultComment,
  avatarUrl,
  isLoading,
  inputLabel,
  cancelButtonLabel,
  commentButtonLabel,
  onCancel,
  onComment,
  isReply,
  metionUserName
}) => {
  const [withMention, setWithMention] = React.useState(!!metionUserName);
  const {
    t
  } = useTranslation();
  const [comment, setComment] = React.useState(defaultComment !== null && defaultComment !== void 0 ? defaultComment : '');
  const handleCancel = () => {
    setComment('');
    if (onCancel) {
      onCancel();
    }
  };
  const handleComment = () => {
    if (onComment) {
      onComment(comment, withMention);
    }
    setComment('');
  };
  const isSubmitButtonOnEditEnabled = defaultComment !== comment && comment.length > 0;
  // remove mention when user backspace the start of the input
  const handleKeyDown = event => {
    var _a;
    if (!withMention) return;
    const targetValue = (_a = event.target) === null || _a === void 0 ? void 0 : _a.value;
    if (event.key !== 'Backspace' || targetValue !== '') return;
    setWithMention(false);
  };
  return jsxs(Stack, Object.assign({
    direction: "row",
    gap: 3,
    position: "relative"
  }, {
    children: [isLoading && jsx(Box, Object.assign({
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#fff"
    }, {
      children: jsx(CircularProgress, {
        color: "inherit"
      })
    })), _showAvatar && jsx(Avatar, {
      src: avatarUrl !== null && avatarUrl !== void 0 ? avatarUrl : String(img),
      sx: {
        width: _avatarSize,
        height: _avatarSize,
        opacity: isLoading ? 0 : 1,
        pointerEvents: isLoading ? 'none' : 'auto'
      },
      "data-testid": "avatar"
    }), jsxs(Stack, Object.assign({
      width: "100%",
      style: {
        opacity: isLoading ? 0 : 1,
        pointerEvents: isLoading ? 'none' : 'auto'
      }
    }, {
      children: [jsx(TextField, {
        fullWidth: true,
        type: "text",
        label: inputLabel !== null && inputLabel !== void 0 ? inputLabel : t('inputComment.label'),
        multiline: true,
        mb: 1,
        size: "small",
        value: comment,
        onChange: e => {
          const totalLength = new TextNewlineLengthUseCase().execute(e.target.value);
          if (totalLength <= 1050) {
            setComment(e.target.value);
          }
        },
        onKeyDown: handleKeyDown,
        "data-testid": "comment-input",
        focusBorderColor: "white",
        labelColor: "white",
        InputProps: {
          startAdornment: withMention && jsx(Text, Object.assign({
            color: "primary",
            width: "fit-content",
            whiteSpace: "nowrap",
            mr: 1
          }, {
            children: metionUserName
          }))
        }
      }), jsx(Text, Object.assign({
        variant: "body2",
        color: "neutralPrimary"
      }, {
        children: t('inputComment.caractheresRemaining', {
          count: new TextNewlineLengthUseCase().execute(comment)
        })
      })), (comment.length > 0 || isReply) && jsxs(Stack, Object.assign({
        mt: 2,
        direction: "row",
        justifyContent: "flex-end",
        gap: 2
      }, {
        children: [jsx(AssistChip, {
          label: cancelButtonLabel !== null && cancelButtonLabel !== void 0 ? cancelButtonLabel : t('inputComment.cancel'),
          size: "small",
          onClick: handleCancel,
          variant: "text"
        }), jsx(AssistChip, {
          label: commentButtonLabel !== null && commentButtonLabel !== void 0 ? commentButtonLabel : t('inputComment.submit'),
          size: "small",
          onClick: handleComment,
          hierarchy: "secondary",
          variant: "filled",
          disabled: !isSubmitButtonOnEditEnabled
        })]
      }))]
    }))]
  }));
};

export { InputComment };
